'use client'

import Loader from '@mercadoni/sinister/dist/cjs/mystiqueLoader'
import React from 'react'
import styled from 'styled-components'

const SkeletonAdsStyled = styled.div<{ aspectRatio: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;
  aspect-ratio: ${(props) => props.aspectRatio};
  border-radius: var(--spacing-borderRadius-large);
`

const SkeletonAds = ({ aspectRatio }: { aspectRatio: string }) => (
  <SkeletonAdsStyled aspectRatio={aspectRatio}>
    <Loader />
  </SkeletonAdsStyled>
)

export default React.memo(SkeletonAds)
